<template>
   <div>
    <dropper :index="index" :level="2" class="bottom30"></dropper>
        <div class="cmsComponent">
           
            <div v-if="$parent.editMode" class="delete is-pulled-right" @click="remove"></div>
            <div class="columns top10" style="margin-bottom: 10px">
                <div class="column is-one-third">
                    <div class="columnDrop"  :class="{removeBorder: !$parent.editMode}">
                        <colDrop :index="0"></colDrop>
                    </div>
                </div>
                <div class="column">
                  <!--  <div ref="title" class="has-text-white is-size-3" :contenteditable="$parent.editMode" @focus="setDirty('title')" @blur="update('title')">
                     <b>{{params.title}}</b>
                   </div> -->

                   <div ref="text" class="has-text-white">
                        <div v-show="focused!='text' || !$parent.editMode">
                            <div class="ql-snow top-20">
                                <div class="ql-editor" style="min-height: 0">
                                    <div v-html="localTxt"  @click="setDirty('text')"></div>
                                </div>
                             </div>
                        </div>

                        <div v-show="$parent.editMode && focused=='text'">
                            <vue-editor :id="'editor' + index"  v-model="localTxt" :editorToolbar="customToolbar"></vue-editor>
                            <button class="button is-coolGreen" @click="update('text')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                        </div>
                   </div>
                </div>
               
            </div>
           
        </div>
   </div>
</template>


<script>
import dropper from './sectionDropper.vue'
import colDrop from './colDrop.vue'
import { AZEventBus } from '../AZEventBus'
import { VueEditor } from "vue2-editor";

export default{
    props: {params: Object, index: Number},
    components: {dropper, colDrop, VueEditor},
    data: function(){
        return {
            dirty: '',
            imgId: 1,
            images: [],
            remImages: [],
            focused: false,
            localTxt: this.params.text.split('**eq**').join('='),
            customToolbar: [
                            [{
                    header: [false, 1, 2, 3, 4, 5, 6]
                }],
                ["bold", "italic", "underline", "strike"],
                [{
                        align: ""
                    }, {
                        align: "center"
                    }, {
                        align: "right"
                    }, {
                        align: "justify"
                }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link","image", "video"],
                [{
                        indent: "-1"
                    }, {
                        indent: "+1"
                    }], // outdent/indent
                    [{
                        color: ['rgb(255,255,255)','rgb(241,194,50)','rgb(255,153,0)', 'rgb(150,150,150)']
                    }, {
                        background: []
                }]
            ]
        }
    },

    mounted: function(){


        var self = this;
        // Select the node that will be observed for mutations
        const targetNode = document.getElementById("editor" + this.index);

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {

                    if(mutation.addedNodes[0] && mutation.addedNodes[0].tagName  == 'IMG'){
                        if(mutation.addedNodes[0].src.split('m-ii-cms-img').length > 1){
                            setTimeout(() => {
                                mutation.addedNodes[0].setAttribute('width', mutation.addedNodes[0].naturalWidth + 'px')
                                mutation.addedNodes[0].setAttribute('height', 'auto')
                                mutation.addedNodes[0].style['max-height'] = ''
                            }, 5)
                            
                        /*   var i = document.createElement("img")
                            i.setAttribute('src', mutation.addedNodes[0].src)
                            mutation.addedNodes[0].appendChild(i) */
                        } else {
                            mutation.addedNodes[0].azId = self.imgId
                            self.images.push({mut: mutation.addedNodes[0], id: self.imgId})
                            self.imgId += 1;
                        }

                    
                    }
                        

                    if(mutation.removedNodes[0] && mutation.removedNodes[0].tagName == 'IMG'){
                        if(mutation.removedNodes[0].azId){
                            //remove from image array
                            self.images = self.images.filter(e => {
                                return e.id != mutation.removedNodes[0].azId
                            })

                        } /* else {
                            //set to be removed from server
                            self.remImages.push({url: self.images.push(mutation.addedNodes[0].src)})
                        } */
                    }
                    

                } else if (mutation.type === "attributes") {
                    //console.log(`The ${mutation.attributeName} attribute was modified.`);
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    },
    

    methods: {

        
        update: function(t){
          
          var self = this;
          this.focused = false

          this.localTxt = az.convertATagsToSelf(this.localTxt)

          var mut = null
          if(this.images.length){

            var count = 0
            
                function w(d){

                    var a = self.images.find(n => {
                        return n.mut.azId == d.id
                    })

                    a.mut.src = d.img

                    count += 1
                    if((self.localTxt != self.dirty) && count == self.images.length){
                        
                        setTimeout(() => {
                            self.$parent.source[self.index].params.text = self.localTxt.split('=').join('**eq**')
                        }, 5)
                    
                        AZEventBus.$emit('pageChanged', null)
                    }
                }

                function n(){
                    
                }

            
                this.images.forEach((e) => {
                    self.$root.app.apiClient.post('subs/data/cmsimg', {imgFile: e.mut.src, id: e.mut.azId}, w, n)
                })
                
            } else {
                if(self.localTxt != this.dirty){
                    this.$parent.source[this.index].params.text = this.localTxt.split('=').join('**eq**')
                    AZEventBus.$emit('pageChanged', null)
                }
            }

        },

        cancel: function(){
            this.focused = false
            this.localTxt = this.$parent.source[this.index].params.text.split('**eq**').join('=')
        },

        remove: function(){
            this.$parent.removeSection(this.index)
        },

        setDirty: function(t){
            if(this.$parent.editMode){
                this.focused = t
                this.dirty = this.localTxt
            }
        }
    }
}


</script>